import { render, staticRenderFns } from "./repairsDetail.vue?vue&type=template&id=32240180&scoped=true"
import script from "./repairsDetail.vue?vue&type=script&lang=js"
export * from "./repairsDetail.vue?vue&type=script&lang=js"
import style0 from "./repairsDetail.vue?vue&type=style&index=0&id=32240180&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32240180",
  null
  
)

export default component.exports